import React from 'react'
import styled from 'styled-components'



const HomeMobileNav = () => {
    return(
        <MobileNav>
            <h1>Nav</h1>
        </MobileNav>
    )
}

export default HomeMobileNav


const MobileNav = styled.div`
    background-color: black;

`